/**
 * Application configuration
 */
import { getApiUrl, getEnvironment } from './env';

// Helper function to ensure URL has protocol
const ensureUrlHasProtocol = (url: string): string => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return `https://${url}`;
};

// API configuration
export const API_CONFIG = {
  BASE_URL: ensureUrlHasProtocol(getApiUrl()),
  TIMEOUT: 10000, // 10 seconds
  IS_DEVELOPMENT: getEnvironment() === 'development',
};

// App metadata
export const APP_META = {
  NAME: 'DraamView',
  DESCRIPTION: 'Small and microcap market intelligence for NSE and BSE, with scheduled orders on the brokers you already use.',
  VERSION: process.env.NEXT_PUBLIC_APP_VERSION || '1.0.0',
  ENVIRONMENT: getEnvironment(),
};

// Google OAuth configuration
export const GOOGLE_OAUTH_CONFIG = {
  CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || '233554319732-66beeef7vcdb3t5p83hpl0ehoaablp71.apps.googleusercontent.com',
};

// Log configuration in development mode
if (API_CONFIG.IS_DEVELOPMENT) {
  console.log('🔧 Environment:', APP_META.ENVIRONMENT);
  console.log('🔌 API URL:', API_CONFIG.BASE_URL);
} 